import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import {
  useFetchApi,
  Config,
  Translator,
  useRedirect,
  useQueryParams,
} from "@itarget/shared";
import { toast } from "../../redux";
import DetailMyCourseGrouped from "./views/DetailMyCourseGrouped";
import { parseFloat } from "globalthis/implementation";
import { enumsPoll } from "@itarget/shared/src/enums";

const DetailMyCourseGroupContainer = () => {
  const dispatch = useDispatch();
  const { goTo } = useRedirect();
  const refPlayer = useRef();
  const { id } = useParams();
  const { get } = useQueryParams();
  const defaultModule = get("defaultModule");
  const [showVideo, setShowVideo] = useState(false);
  const [showQuiz, setShowQuiz] = useState(false);
  const [showAnswers, setShowAnswers] = useState(false);
  const [endVideo, setEndVideo] = useState(false);
  const [progress, setProgress] = useState({
    playedSeconds: 0,
    played: 0,
    loadedSeconds: 0,
    loaded: 0,
  });
  const [playing, setPlaying] = useState(false);
  const [totalWatch, setTotalWatch] = useState(0);
  const [percentNextVideo, setPercentNextVideo] = useState(1);
  const [lesson, setLesson] = useState({});
  const [speakers, setSpeakers] = useState("");
  const [polls, setPolls] = useState({});
  const selectedLang = useSelector((state) => state.language.lang);
  const user = useSelector((state) => state.auth.user);
  const settingCommerce = useSelector((state) => state.setting.settingCommerce);
  const centerCostId = useSelector((state) => state.auth.cc);
  const [secondsLeft, setSecondsLeft] = useState();
  const [assistedTimeout, setAssistedTimeout] = useState();
  const [secondsLeftQuiz, setSecondsLeftQuiz] = useState();
  const [quizTimeout, setQuizTimeout] = useState();
  const [intervalId, setIntervalId] = useState();
  const [lastPollsInsideIntervals, setLastPollsInsideIntervals] = useState([]);
  const [finalResultsByScheduleId, setFinalResultsByScheduleId] = useState({});
  const [showIframe, setShowIframe] = useState(false);
  const initialDetailFetchDone = useRef(false);
  const repeatedVideoPollCyclesRef = useRef({});

  const translation = {
    exceededResponses: Translator({
      transRef:
        "translation.Atenção: Todas as tentativas disponibilizadas para o participante já foram utilizadas. Não é possível acessar este questionário.",
    }),
    alreadyAnswered: Translator({
      transRef: "translation.Você já respondeu o questionário!",
    }),
    attempts: Translator({
      transRef: "translation.Atenção: Você possui %s tentativas restantes.",
    }).props.children,
    attempt: Translator({
      transRef: "translation.Atenção: Você possui %s tentativa restante.",
    }).props.children,
  };

  useEffect(() => {
    if (settingCommerce?.meta_proximovideo) {
      setPercentNextVideo(parseFloat(settingCommerce?.meta_proximovideo) / 100);
    }
  }, [settingCommerce]);

  const { fetchData: fetchSendVideo } = useFetchApi(
    Config.baseURL + `api/${selectedLang}/video-frequency`,
    "POST"
  );

  const {
    data: getVideo,
    error: errorGetVideo,
    fetchData: fetchGetVideo,
  } = useFetchApi(
    Config.baseURL +
      `api/${selectedLang}/video-frequency/${
        lesson && lesson.agenda_atividade_detalhe_id
      }/resume?pessoa_id=${user.data && user.data.id}`
  );

  const {
    data: detailRequest,
    fetchData: fetchDetailRequest,
    isLoading: isLoadingDetailRequest,
  } = useFetchApi(
    Config.baseURL +
      `api/${selectedLang}/activity-payment/${id}/detailing?centro_custo_id=${centerCostId}${
        user?.data ? "&pessoa_id=" + user.data.id : ""
      }`
  );

  const {
    data: dataDetail,
    error: errorDetail,
    fetchData: fetchDetail,
    isLoading: isLoadingDetail,
  } = useFetchApi(
    Config.baseURL +
      `api/${selectedLang}/activity-schedule/${id}/detail?pessoa_id=${user?.data?.id}&group_by=${detailRequest?.data?.detailing?.[0]?.commerce_ondemand_exibicao}&centro_custo_id=${centerCostId}`
  );

  const {
    data: videoPolls = { data: [] },
    fetchData: fetchVideoPolls,
    isLoading: isLoadingVideoPolls,
  } = useFetchApi(
    `${Config.baseURLV2}api/store/ead/video-polls?scheduleActivityDetailId=${lesson.agenda_atividade_detalhe_id}`,
    "GET",
    {
      Authorization: `Bearer ${user.access_token}`,
    }
  );

  const {
    data: quizResults,
    fetchData: fetchQuizResults,
    isLoading: isLoadingQuizResults,
  } = useFetchApi(
    `${Config.baseURL}api/${selectedLang}/question/activity-schedule-detail/${
      lesson?.agenda_atividade_detalhe_id
    }?pessoa_id=${user?.data?.id}&centro_custo_id=${
      detailRequest?.data?.detailing?.[0]?.centro_custo_id_out || centerCostId
    }`
  );

  const {
    data: questionResult,
    fetchData: getQuestionResult,
    isLoading: isLoadingQuestionResult,
  } = useFetchApi(
    `${Config.baseURL}api/${selectedLang}/question?centro_custo_id=${
      detailRequest?.data?.detailing?.[0]?.centro_custo_id_out || centerCostId
    }&pessoa_id=${user.data.id}&formulario_pergunta_id=${
      lesson?.formulario_pergunta_id
    }&destino_pergunta=${enumsPoll.DESTINATION_QUESTION.QUESTIONNAIRE}`
  );

  const isVideoInsideVideoPolls = videoPolls?.data
    ? videoPolls?.data.some(
        ({ pollId }) => pollId === polls?.formulario_pergunta_id
      )
    : false;

  const { fetchData: getVideoPolls } = useFetchApi();
  const { fetchData: getQuestionList } = useFetchApi();
  const { fetchData: fetchFinalResult, isLoading: isLoadingFinalResult } =
    useFetchApi();

  const { fetchData: fetchTrack } = useFetchApi(
    Config.baseURL + `api/${selectedLang}/log/track`,
    "POST"
  );

  useEffect(() => {
    fetchDetailRequest();
  }, [id, user?.data?.id]);

  useEffect(() => {
    if (
      detailRequest?.data?.detailing?.[0]?.commerce_ondemand_exibicao &&
      !initialDetailFetchDone.current
    ) {
      fetchDetail();
      initialDetailFetchDone.current = true;
    }
    return () => {
      resetState();
      if (id) {
        initialDetailFetchDone.current = false;
      }
    };
  }, [id, detailRequest?.data?.detailing?.[0]?.commerce_ondemand_exibicao]);

  useEffect(() => {
    if (errorGetVideo !== null) {
      dispatch(
        toast.actions.enqueue({
          content: errorGetVideo,
          severity: "error",
        })
      );
    }
  }, [errorGetVideo, dispatch]);

  useEffect(() => {
    if (errorDetail !== null) {
      dispatch(
        toast.actions.enqueue({
          content: errorDetail,
          severity: "error",
        })
      );
    }
  }, [errorDetail, dispatch]);

  useEffect(() => {
    if (lesson?.agenda_atividade_detalhe_id) {
      fetchGetVideo();
    }
  }, [lesson?.agenda_atividade_detalhe_id]);

  useEffect(() => {
    if (getVideo && getVideo.data.posicao && refPlayer.current) {
      const posicao = getVideo.data.posicao;
      setTotalWatch(posicao.playedSeconds);
      if (posicao.played !== 1 && getVideo.data.tipo !== "F") {
        refPlayer.current.seekTo(posicao.played, "fraction");
        setProgress(posicao);
      }
    }
  }, [getVideo]);

  useEffect(() => {
    if (lesson && lesson?.formulario?.length > 0) {
      setPolls(lesson.formulario[0]);
      return;
    }
    setPolls({});
  }, [lesson]);

  useEffect(() => {
    if (lesson?.agenda_atividade_detalhe_id && showVideo) {
      fetchVideoPolls();
    }
  }, [lesson?.agenda_atividade_detalhe_id, showVideo, user?.access_token]);

  useEffect(() => {
    if (showAnswers && lesson?.agenda_atividade_detalhe_id) {
      const isGeneralQuestionnaire =
        lesson?.formulario_pergunta_id &&
        (!videoPolls?.data ||
          !videoPolls.data.some(
            (poll) => poll.pollId === lesson?.formulario_pergunta_id
          ));

      if (isGeneralQuestionnaire) {
        getQuestionResult();
      } else if (videoPolls?.data?.length > 0) {
        fetchQuizResults();
      }
    }
  }, [
    showAnswers,
    lesson?.agenda_atividade_detalhe_id,
    videoPolls?.data,
    lesson?.formulario_pergunta_id,
  ]);

  useEffect(() => {
    if (dataDetail?.data?.grupos) {
      Object.values(dataDetail.data.grupos || {}).forEach((groupData) => {
        Object.values(groupData.groups || {}).forEach(async (subGroupData) => {
          if (subGroupData?.agenda_atividade_detalhe_id) {
            await loadFinalResultsOnExpand(
              subGroupData.agenda_atividade_detalhe_pai_id,
              subGroupData.agenda_atividade_detalhe_id
            );
          }
        });
      });
    }
  }, [dataDetail?.data?.grupos]);

  const fetchFinalResults = async (
    activityScheduleDetailId,
    activityScheduleDetailParentId,
    isReload = false
  ) => {
    if (!activityScheduleDetailId && !activityScheduleDetailParentId) {
      return [];
    }

    const idToCheck =
      activityScheduleDetailId || activityScheduleDetailParentId;
    if (!isReload && finalResultsByScheduleId[idToCheck]) {
      return finalResultsByScheduleId[idToCheck];
    }

    const url =
      Config.baseURL +
      `api/${selectedLang}/question/final-result?personId=${user.data.id}${
        activityScheduleDetailId
          ? `&activityScheduleDetailId=${activityScheduleDetailId}`
          : ""
      }${
        activityScheduleDetailParentId
          ? `&activityScheduleDetailParentId=${activityScheduleDetailParentId}`
          : ""
      }`;

    try {
      const response = await fetchFinalResult(null, url);
      return response.data || [];
    } catch (error) {
      return [];
    }
  };

  const loadFinalResultsOnExpand = async (
    activityScheduleDetailParentId,
    activityScheduleDetailId
  ) => {
    if (isLoadingFinalResult) {
      return;
    }

    try {
      if (!activityScheduleDetailParentId && !activityScheduleDetailId) {
        return;
      }

      const updates = {};

      if (
        activityScheduleDetailParentId &&
        !finalResultsByScheduleId[activityScheduleDetailParentId]
      ) {
        const parentResults = await fetchFinalResults(
          null,
          activityScheduleDetailParentId
        );
        if (parentResults && parentResults.length > 0) {
          updates[activityScheduleDetailParentId] = parentResults;
        }
      }

      if (
        activityScheduleDetailId &&
        !finalResultsByScheduleId[activityScheduleDetailId]
      ) {
        const childResults = await fetchFinalResults(
          activityScheduleDetailId,
          null
        );
        if (childResults && childResults.length > 0) {
          updates[activityScheduleDetailId] = childResults;
        }
      }

      if (Object.keys(updates).length > 0) {
        setFinalResultsByScheduleId((prev) => ({
          ...prev,
          ...updates,
        }));
      }
    } catch (error) {
      console.error("[loadFinalResultsOnExpand] Erro:", error);
    }
  };

  const loadFinalResultsOnEachItem = async (activityScheduleDetailId) => {
    if (!activityScheduleDetailId) {
      return;
    }

    if (isLoadingFinalResult) {
      return;
    }

    if (finalResultsByScheduleId[activityScheduleDetailId]) {
      return;
    }

    try {
      const results = await fetchFinalResults(activityScheduleDetailId);

      if (results && results.length > 0) {
        setFinalResultsByScheduleId((prev) => ({
          ...prev,
          [activityScheduleDetailId]: results,
        }));
      }
    } catch (error) {
      console.error("[loadFinalResultsOnEachItem] Erro:", error);
    }
  };

  const reloadFinalResults = async (
    activityScheduleDetailId = null,
    activityScheduleDetailParentId = null
  ) => {
    if (!activityScheduleDetailId && !activityScheduleDetailParentId) {
      return;
    }

    try {
      const idToUse =
        activityScheduleDetailId || activityScheduleDetailParentId;
      const results = await fetchFinalResults(
        activityScheduleDetailId,
        activityScheduleDetailParentId,
        true
      );

      if (results && results.length > 0) {
        setFinalResultsByScheduleId((prev) => ({
          ...prev,
          [idToUse]: results,
        }));
      }
    } catch (error) {
      console.error("[reloadFinalResults] Error:", error);
    }
  };

  const selectStep = (lesson, speakers, type) => {
    setLesson(lesson);
    setSpeakers(speakers);
    if (["video-poll", "question"].includes(type)) {
      setShowQuiz(true);

      const quiz = lesson.formulario?.[0];
      const isUnlimitedTypeTwoVideoPoll =
        type === "video-poll" && Number(quiz?.tipo) === 2;

      if (quiz) {
        if (!quiz.pode_responder && !isUnlimitedTypeTwoVideoPoll) {
          dispatch(
            toast.actions.enqueue({
              content: quiz.mensagem_limite_tempo,
              severity: "info",
            })
          );
          setShowQuiz(false);
          return false;
        }
        fetchTrack(
          JSON.stringify({
            trackable_id: quiz.formulario_pergunta_id,
            trackable_type: "formularios_perguntas",
            pessoa_id: user.data.id,
            action: "QUIZ_STARTED",
          })
        );
        setPolls(quiz);
        initializePollTimer(lesson);
      } else {
        setPolls({ pergunta: [] });
      }

      return true;
    }
    if (type === "answers") {
      setShowVideo(false);
      setShowQuiz(false);
      setShowAnswers(true);
      return true;
    }
    if (!lesson.pode_assistir) {
      dispatch(
        toast.actions.enqueue({
          content: lesson.mensagem_limite_tempo,
          severity: "info",
        })
      );
      setShowQuiz(false);
      return false;
    }
    setShowVideo(true);
    return true;
  };

  const handleModalIframe = (lesson, value) => {
    setLesson(lesson);
    setShowIframe(value);
  };

  const resetState = () => {
    refPlayer.current = null;
    repeatedVideoPollCyclesRef.current = {};
    setProgress({ playedSeconds: 0, played: 0, loadedSeconds: 0, loaded: 0 });
    setTotalWatch(0);
    setLesson({});
    setEndVideo(false);
    setSecondsLeft();
    setAssistedTimeout();
    setSecondsLeftQuiz();
    setQuizTimeout();
    setIntervalId();
  };

  const sendVideo = (tipo, posicao) => {
    const seconds =
      posicao !== undefined ? posicao.playedSeconds : progress.playedSeconds;

    fetchSendVideo(
      JSON.stringify({
        agenda_atividade_detalhe_id: lesson.agenda_atividade_detalhe_id,
        pessoa_id: user.data.id,
        tipo: tipo,
        posicao: posicao ? posicao : progress,
        replay: totalWatch > seconds || endVideo ? "S" : "N",
      })
    );
  };

  const closeShowVideo = () => {
    refPlayer.current = null;
    repeatedVideoPollCyclesRef.current = {};
    setShowVideo(false);
    setLesson({});
    setTotalWatch(0);
    setProgress({ playedSeconds: 0, played: 0, loadedSeconds: 0, loaded: 0 });
  };

  const onPause = (e) => {
    setPlaying(false);
    if (e.percent < 1) {
      sendVideo("P");
    }
  };

  const onPlay = () => {
    sendVideo("I");
    setPlaying(true);
    if (!lesson.data_inicio_video && lesson.disponivel_por > 0) {
      fetchTrack(
        JSON.stringify({
          trackable_id: lesson.agenda_atividade_detalhe_id,
          trackable_type: "agenda_atividades_detalhes",
          pessoa_id: user.data.id,
          action: "VIDEO_STARTED",
        })
      );
    }
    limitTimeVideo();
  };

  const fetchQuestions = async (fetchFunction, id) => {
    const { data } = await fetchFunction(
      null,
      `${Config.baseURL}api/${selectedLang}/question?centro_custo_id=${
        detailRequest?.data?.detailing?.[0]?.centro_custo_id_out || centerCostId
      }&pessoa_id=${
        user.data.id
      }&formulario_pergunta_id=${id}&destino_pergunta=${
        enumsPoll.DESTINATION_QUESTION.QUESTIONNAIRE
      }`
    );
    return data;
  };

  const openQuestionFromCurrentLessonWithQuestionId = async (course) => {
    const treatedLesson = course;
    treatedLesson.formulario = [];

    if (!treatedLesson.formulario_pergunta_id) return false;

    const questionList = await fetchQuestions(
      getQuestionList,
      course.formulario_pergunta_id
    );

    if (questionList) treatedLesson.formulario = questionList;

    return selectStep(treatedLesson, speakers, "question");
  };

  const openPollFromCurrentLessonWithPollId = async (videoPoll) => {
    const treatedLesson = lesson;
    treatedLesson.formulario = [];

    const [poll] = await fetchQuestions(getVideoPolls, videoPoll?.pollId);

    if (poll) {
      treatedLesson.formulario.push({
        ...poll,
        tipo: videoPoll?.tipo,
      });
    }

    return selectStep(lesson, speakers, "video-poll");
  };

  const getCurrentPollId = (playedSeconds) => {
    const lastPollsInsideIntervals = videoPolls?.data?.filter(
      ({ pauseTimeSecond, tipo }) => {
        if (Number(tipo) === 2) {
          return false;
        }
        return (
          pauseTimeSecond <= playedSeconds &&
          pauseTimeSecond + 10 >= playedSeconds
        );
      }
    );

    setLastPollsInsideIntervals(lastPollsInsideIntervals);
    return lastPollsInsideIntervals
      ? lastPollsInsideIntervals[lastPollsInsideIntervals.length - 1]
      : {};
  };

  const isCurrentInsidePollInsideIntervalArray = (
    currentPollInsideInterval
  ) => {
    return lastPollsInsideIntervals?.some(
      ({ pauseTimeSecond }) =>
        pauseTimeSecond === currentPollInsideInterval.pauseTimeSecond
    );
  };

  const verifyPollInsideVideoWithPlayedSeconds = async (playedSeconds) => {
    if (!playedSeconds) return;

    const currentRepeatedPoll = videoPolls?.data?.find((videoPoll) => {
      if (Number(videoPoll?.tipo) !== 2) {
        return false;
      }

      const intervalSeconds = Number(videoPoll?.pauseTimeSecond);
      if (!intervalSeconds || intervalSeconds < 1) {
        return false;
      }

      const currentCycle = Math.floor(playedSeconds / intervalSeconds);
      if (currentCycle < 1) {
        return false;
      }

      const lastTriggeredCycle =
        repeatedVideoPollCyclesRef.current[videoPoll.id] || 0;

      if (currentCycle <= lastTriggeredCycle) {
        return false;
      }

      repeatedVideoPollCyclesRef.current[videoPoll.id] = currentCycle;
      return true;
    });

    if (currentRepeatedPoll) {
      const canOpenPoll = await openPollFromCurrentLessonWithPollId(
        currentRepeatedPoll
      );
      if (!canOpenPoll) return;
      document.exitFullscreen();
      setPlaying(false);
      return;
    }

    const currentPollInsideInterval = getCurrentPollId(playedSeconds);
    if (!currentPollInsideInterval) return;
    if (isCurrentInsidePollInsideIntervalArray(currentPollInsideInterval))
      return;
    const canOpenPoll = await openPollFromCurrentLessonWithPollId(
      currentPollInsideInterval
    );
    if (!canOpenPoll) return;
    document.exitFullscreen();
    setPlaying(false);
  };

  const onProgress = (progressEvent) => {
    verifyPollInsideVideoWithPlayedSeconds(progressEvent.playedSeconds);
    if (totalWatch < progressEvent.playedSeconds) {
      setTotalWatch(progressEvent.playedSeconds);
    }
    setProgress(progressEvent);
    sendVideo(progressEvent.played < 1 ? "P" : "F", progressEvent);
  };

  const onEnded = () => {
    const position = {
      playedSeconds: progress.loadedSeconds,
      played: 1,
      loadedSeconds: progress.loadedSeconds,
      loaded: progress.loaded,
    };
    setTotalWatch(progress.loadedSeconds);
    setPlaying(false);
    sendVideo("F", position);
    setEndVideo(true);
    setProgress({ playedSeconds: 0, played: 0, loadedSeconds: 0, loaded: 0 });
  };

  const closeShowQuiz = async () => {
    try {
      if (
        detailRequest?.data?.detailing?.[0]?.commerce_ondemand_exibicao == 1
      ) {
        await reloadFinalResults(lesson.agenda_atividade_detalhe_id);
      }
      if (
        detailRequest?.data?.detailing?.[0]?.commerce_ondemand_exibicao == 2 &&
        lesson.agenda_atividade_detalhe_pai_id
      ) {
        await reloadFinalResults(null, lesson.agenda_atividade_detalhe_pai_id);
      }
      if (intervalId) {
        clearInterval(intervalId);
      }
      setShowQuiz(false);
    } catch (error) {
      console.error("[closeShowQuiz] Error:", error);
    }
  };

  const closeShowAnswers = () => {
    setShowAnswers(false);
  };

  const setOpenPoll = () => {
    if (dataDetail?.data?.perguntas?.respondido) {
      dispatch(
        toast.actions.enqueue({
          content: translation.alreadyAnswered,
          severity: "info",
        })
      );
    } else {
      setPolls(dataDetail.data.perguntas);
      setShowQuiz(true);
    }
  };

  const setOpenCertificate = (url) => {
    window.open(url);
  };

  const limitTimeVideo = () => {
    if (intervalId) {
      clearInterval(intervalId);
    }
    const newIntervalId = setInterval(() => {
      if (assistedTimeout) {
        setAssistedTimeout((assisted) => {
          assisted -= 1;
          return assisted;
        });
      }
      if (secondsLeft) {
        setSecondsLeft((seconds) => {
          if (seconds < 1) {
            goTo(`my-course/${lesson.agenda_atividade_id}`);
            return;
          }
          seconds -= 1;
          return seconds;
        });
      }
    }, 1000);

    setIntervalId(newIntervalId);
  };

  const limitTimeQuiz = () => {
    if (intervalId) {
      clearInterval(intervalId);
    }
    const newIntervalId = setInterval(() => {
      if (quizTimeout) {
        setQuizTimeout((quizView) => {
          quizView -= 1;
          return quizView;
        });
      }
      if (
        secondsLeftQuiz < 1 &&
        videoPolls?.data?.length > 0 &&
        polls?.tipo !== 2
      ) {
        closeShowQuiz();
        setPlaying(true);
      }
      if (secondsLeftQuiz < 1 && videoPolls?.data?.length === 0) {
        goTo(`my-course/${lesson.agenda_atividade_id}`);
      }
      if (secondsLeftQuiz) {
        setSecondsLeftQuiz((seconds) => {
          seconds -= 1;
          return seconds;
        });
      }
    }, 1000);

    setIntervalId(newIntervalId);
  };

  const onEndQuizCallback = async (quiz) => {
    try {
      if (
        detailRequest?.data?.detailing?.[0]?.commerce_ondemand_exibicao == 1
      ) {
        await reloadFinalResults(lesson.agenda_atividade_detalhe_id);
      }
      if (
        detailRequest?.data?.detailing?.[0]?.commerce_ondemand_exibicao == 2
      ) {
        if (lesson.agenda_atividade_detalhe_pai_id) {
          await reloadFinalResults(
            null,
            lesson.agenda_atividade_detalhe_pai_id
          );
        }
        if (lesson.agenda_atividade_detalhe_id) {
          await reloadFinalResults(lesson.agenda_atividade_detalhe_id);
        }
      }
      if (detailRequest?.data?.detailing?.[0]?.commerce_ondemand_exibicao) {
        fetchDetail();
      }

      if (videoPolls?.data?.length > 0) {
        setPlaying(true);
      }
    } catch (error) {
      console.error("[onEndQuizCallback] Error:", error);
    }
  };

  useEffect(() => {
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const initializePollTimer = (lesson) => {
    setSecondsLeftQuiz();
    setQuizTimeout();

    if (lesson) {
      if (lesson.disponivel_por) {
        if (lesson.data_inicio_video) {
          const date1 = new Date(
            lesson.data_inicio_video.replace(/\.\d+$/, "").replace(" ", "T")
          );
          const date2 = new Date(lesson.data_hora);
          const differenceInSeconds = Number.parseInt(
            Math.abs((date1.getTime() - date2.getTime()) / 1000)
          );
          setSecondsLeft(lesson.disponivel_por * 60 - differenceInSeconds);
        } else {
          setSecondsLeft(lesson.disponivel_por * 60);
        }
      }

      if (Number(lesson?.formulario?.[0]?.tipo) === 2) {
        return;
      }

      if (lesson?.formulario?.[0]?.disponivel_por) {
        if (lesson?.formulario?.[0]?.data_inicio_questionario) {
          const date1 = new Date(
            lesson?.formulario?.[0]?.data_inicio_questionario
              .replace(/\.\d+$/, "")
              .replace(" ", "T")
          );
          const date2 = new Date(lesson?.formulario?.[0]?.data_hora);
          const differenceInSeconds = Number.parseInt(
            Math.abs((date1.getTime() - date2.getTime()) / 1000)
          );
          setSecondsLeftQuiz(
            lesson?.formulario?.[0]?.disponivel_por * 60 - differenceInSeconds
          );
        } else {
          setSecondsLeftQuiz(lesson?.formulario?.[0]?.disponivel_por * 60);
        }
      }
    }
  };

  useEffect(() => {
    initializePollTimer(lesson);
  }, [lesson]);

  return (
    <DetailMyCourseGrouped
      isLoading={
        isLoadingDetail || isLoadingVideoPolls || isLoadingDetailRequest
      }
      isLoadingDetail={isLoadingDetail}
      id={id}
      totalWatch={totalWatch}
      playing={playing}
      refPlayer={refPlayer}
      showVideo={showVideo}
      showQuiz={showQuiz}
      showAnswers={showAnswers}
      detail={dataDetail}
      lesson={lesson}
      speakers={speakers}
      polls={polls}
      isVideoInsideVideoPolls={isVideoInsideVideoPolls}
      canControlVideoProgressBar={!videoPolls?.data?.length}
      closeShowVideo={closeShowVideo}
      closeShowAnswers={closeShowAnswers}
      selectStep={selectStep}
      onPause={onPause}
      onPlay={onPlay}
      onProgress={onProgress}
      onEnded={onEnded}
      closeShowQuiz={closeShowQuiz}
      setOpenPoll={setOpenPoll}
      setOpenCertificate={setOpenCertificate}
      percentNextVideo={percentNextVideo}
      secondsLeft={secondsLeft}
      secondsLeftQuiz={secondsLeftQuiz}
      limitTimeQuiz={limitTimeQuiz}
      onEndQuizCallback={onEndQuizCallback}
      detailRequest={detailRequest}
      ondemandFormat={
        detailRequest?.data?.detailing?.[0]?.commerce_ondemand_exibicao
      }
      defaultModule={defaultModule}
      openQuestionFromCurrentLessonWithQuestionId={
        openQuestionFromCurrentLessonWithQuestionId
      }
      quizResults={
        questionResult?.data?.[0]
          ? { data: [{ formulario: questionResult?.data?.[0] }] }
          : quizResults
      }
      isLoadingQuizResults={
        isLoadingQuizResults || isLoadingQuestionResult || isLoadingVideoPolls
      }
      onOpenSubmodule={loadFinalResultsOnExpand}
      finalResultsByScheduleId={finalResultsByScheduleId}
      isLoadingFinalResult={isLoadingFinalResult}
      settingCommerce={settingCommerce}
      loadFinalResultsOnEachItem={loadFinalResultsOnEachItem}
      showIframe={showIframe}
      handleModalIframe={handleModalIframe}
    />
  );
};

export default DetailMyCourseGroupContainer;
